module.exports = __webpack_public_path__ + "img/202408_07.cfd009cb.jpg";